import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7df9195e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["disabled", "aria-busy"]
const _hoisted_2 = {
  key: 0,
  class: "frisbuy-loadmore-button__loader",
  "aria-hidden": "true"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Показать еще", -1))


export default /*#__PURE__*/_defineComponent({
  __name: 'LoadMoreButton',
  props: {
  countOfPages: {
    type: Number,
    required: true,
    validator: (val: number) => val > 0,
  },

  selectedPage: {
    type: Number,
    required: true,
    validator: (val: number) => val >= 1,
  },

  isLoadPosts: {
    type: Boolean,
    required: true,
  },
},
  emits: ["selectPage"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

function selectPage(page: number) {
  let pageForEmit = page;

  if (pageForEmit < 1) {
    pageForEmit = 1;
  } else if (pageForEmit > props.countOfPages) {
    pageForEmit = props.countOfPages;
  }

  if (pageForEmit === props.selectedPage) {
    return;
  }

  emit("selectPage", pageForEmit);
}

return (_ctx: any,_cache: any) => {
  return (props.selectedPage < props.countOfPages)
    ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        class: "frisbuy-loadmore-button",
        disabled: props.isLoadPosts,
        "aria-busy": props.isLoadPosts ? 'true' : 'false',
        onClick: _cache[0] || (_cache[0] = () => selectPage(props.selectedPage + 1))
      }, [
        (props.isLoadPosts)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2))
          : _createCommentVNode("", true),
        _hoisted_3
      ], 8, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})